import React from 'react';

import { cn } from '@/utils';

type Props = React.HTMLAttributes<HTMLElement> & {
  content: Element | string | number;
  color: 'green' | 'hem-pro' | 'blue' | 'red' | 'gray';
};

export const Pill: React.FC<Props> = ({
  content,
  color,
  className,
  ...rest
}): JSX.Element => {
  return (
    <span
      className={cn(
        'ml-1 inline-flex content-center justify-center whitespace-nowrap rounded-full bg-black-300 px-2 text-sm font-bold',
        className,
        {
          'bg-success text-white': color === 'green',
          'bg-blue text-white': color === 'blue',
          'bg-red-matte text-red-gloss': color === 'red',
          'text-black bg-black-100': color === 'gray',
          'text-green-gloss bg-green-matte': color === 'hem-pro',
        },
      )}
      {...rest}
    >
      {content}
    </span>
  );
};
